/** 首页轮播第 1 张：底图固定，文案随语言切换 */
export const heroBannerTranslations = {
  zh: {
    heroBanner1Title: "SGS认证 实力工厂",
    heroBanner1MetricPrefix: "年产量",
    heroBanner1MetricSuffix: "台",
    heroBanner1Feature1: "机器出口172个国家",
    heroBanner1Feature2: "支持OEM/ODM代工",
    heroBanner1Feature3: "6S服务 行业独有",
    heroBanner1Feature4: "支持各种方案定制",
  },
  en: {
    heroBanner1Title: "SGS CERTIFIED FACTORY",
    heroBanner1MetricPrefix: "ANNUAL OUTPUT",
    heroBanner1MetricSuffix: "UNITS",
    heroBanner1Feature1: "Machines Exported to 172 Countries",
    heroBanner1Feature2: "Supports OEM/ODM",
    heroBanner1Feature3: "6S Service · Industry Exclusive",
    heroBanner1Feature4: "Custom Solutions for Every Need",
  },
  de: {
    heroBanner1Title: "SGS-ZERTIFIZIERTE FABRIK",
    heroBanner1MetricPrefix: "JAHRESAUSSTOSS",
    heroBanner1MetricSuffix: "GERÄTE",
    heroBanner1Feature1: "Maschinenexport in 172 Länder",
    heroBanner1Feature2: "OEM/ODM-Unterstützung",
    heroBanner1Feature3: "6S-Service · Branchenexklusiv",
    heroBanner1Feature4: "Individuelle Lösungsanpassung",
  },
  pt: {
    heroBanner1Title: "FÁBRICA CERTIFICADA SGS",
    heroBanner1MetricPrefix: "PRODUÇÃO ANUAL",
    heroBanner1MetricSuffix: "UNIDADES",
    heroBanner1Feature1: "Máquinas exportadas para 172 países",
    heroBanner1Feature2: "Suporte OEM/ODM",
    heroBanner1Feature3: "Serviço 6S · Exclusivo do setor",
    heroBanner1Feature4: "Suporte a soluções sob medida",
  },
  es: {
    heroBanner1Title: "FÁBRICA CERTIFICADA SGS",
    heroBanner1MetricPrefix: "PRODUCCIÓN ANUAL",
    heroBanner1MetricSuffix: "UNIDADES",
    heroBanner1Feature1: "Máquinas exportadas a 172 países",
    heroBanner1Feature2: "Soporte OEM/ODM",
    heroBanner1Feature3: "Servicio 6S · Exclusivo del sector",
    heroBanner1Feature4: "Soporte de soluciones a medida",
  },
  fr: {
    heroBanner1Title: "USINE CERTIFIÉE SGS",
    heroBanner1MetricPrefix: "PRODUCTION ANNUELLE",
    heroBanner1MetricSuffix: "UNITÉS",
    heroBanner1Feature1: "Machines exportées vers 172 pays",
    heroBanner1Feature2: "Support OEM/ODM",
    heroBanner1Feature3: "Service 6S · Exclusif au secteur",
    heroBanner1Feature4: "Solutions sur mesure",
  },
  it: {
    heroBanner1Title: "FABBRICA CERTIFICATA SGS",
    heroBanner1MetricPrefix: "PRODUZIONE ANNUALE",
    heroBanner1MetricSuffix: "UNITÀ",
    heroBanner1Feature1: "Macchine esportate in 172 paesi",
    heroBanner1Feature2: "Supporto OEM/ODM",
    heroBanner1Feature3: "Servizio 6S · Esclusivo del settore",
    heroBanner1Feature4: "Supporto soluzioni su misura",
  },
  hi: {
    heroBanner1Title: "SGS प्रमाणित फैक्टरी",
    heroBanner1MetricPrefix: "वार्षिक उत्पादन",
    heroBanner1MetricSuffix: "यूनिट",
    heroBanner1Feature1: "172 देशों में मशीन निर्यात",
    heroBanner1Feature2: "OEM/ODM समर्थन",
    heroBanner1Feature3: "6S सेवा · उद्योग विशिष्ट",
    heroBanner1Feature4: "कस्टम समाधान समर्थन",
  },
  ru: {
    heroBanner1Title: "ЗАВОД С СЕРТИФИКАТОМ SGS",
    heroBanner1MetricPrefix: "ГОДОВОЙ ВЫПУСК",
    heroBanner1MetricSuffix: "ШТ.",
    heroBanner1Feature1: "Экспорт машин в 172 страны",
    heroBanner1Feature2: "Поддержка OEM/ODM",
    heroBanner1Feature3: "Сервис 6S · Уникально в отрасли",
    heroBanner1Feature4: "Индивидуальные решения",
  },
  ko: {
    heroBanner1Title: "SGS 인증 공장",
    heroBanner1MetricPrefix: "연간 생산량",
    heroBanner1MetricSuffix: "대",
    heroBanner1Feature1: "172개국 기계 수출",
    heroBanner1Feature2: "OEM/ODM 지원",
    heroBanner1Feature3: "6S 서비스 · 업계 유일",
    heroBanner1Feature4: "맞춤 솔루션 지원",
  },
  ja: {
    heroBanner1Title: "SGS認証工場",
    heroBanner1MetricPrefix: "年間生産台数",
    heroBanner1MetricSuffix: "台",
    heroBanner1Feature1: "172カ国へ機械を輸出",
    heroBanner1Feature2: "OEM/ODM対応",
    heroBanner1Feature3: "6Sサービス · 業界独自",
    heroBanner1Feature4: "方案カスタマイズ対応",
  },
  th: {
    heroBanner1Title: "โรงงานรับรอง SGS",
    heroBanner1MetricPrefix: "กำลังผลิตต่อปี",
    heroBanner1MetricSuffix: "เครื่อง",
    heroBanner1Feature1: "ส่งออกเครื่องจักร 172 ประเทศ",
    heroBanner1Feature2: "รองรับ OEM/ODM",
    heroBanner1Feature3: "บริการ 6S · เฉพาะในอุตสาหกรรม",
    heroBanner1Feature4: "รองรับการออกแบบโซลูชัน",
  },
  tr: {
    heroBanner1Title: "SGS SERTİFİKALI FABRİKA",
    heroBanner1MetricPrefix: "YILLIK ÜRETİM",
    heroBanner1MetricSuffix: "ADET",
    heroBanner1Feature1: "172 ülkeye makine ihracatı",
    heroBanner1Feature2: "OEM/ODM desteği",
    heroBanner1Feature3: "6S hizmet · Sektöre özel",
    heroBanner1Feature4: "Özel çözüm desteği",
  },
  vi: {
    heroBanner1Title: "NHÀ MÁY CHỨNG NHẬN SGS",
    heroBanner1MetricPrefix: "SẢN LƯỢNG NĂM",
    heroBanner1MetricSuffix: "MÁY",
    heroBanner1Feature1: "Xuất khẩu máy đến 172 quốc gia",
    heroBanner1Feature2: "Hỗ trợ OEM/ODM",
    heroBanner1Feature3: "Dịch vụ 6S · Độc quyền ngành",
    heroBanner1Feature4: "Hỗ trợ tùy chỉnh giải pháp",
  },
  nl: {
    heroBanner1Title: "SGS-GECERTIFICEERDE FABRIEK",
    heroBanner1MetricPrefix: "JAARLIJKSE PRODUCTIE",
    heroBanner1MetricSuffix: "STUKS",
    heroBanner1Feature1: "Machines geëxporteerd naar 172 landen",
    heroBanner1Feature2: "OEM/ODM-ondersteuning",
    heroBanner1Feature3: "6S-service · Uniek in de branche",
    heroBanner1Feature4: "Ondersteuning op maat gemaakte oplossingen",
  },
  id: {
    heroBanner1Title: "PABRIK BERSERTIFIKAT SGS",
    heroBanner1MetricPrefix: "PRODUKSI TAHUNAN",
    heroBanner1MetricSuffix: "UNIT",
    heroBanner1Feature1: "Mesin diekspor ke 172 negara",
    heroBanner1Feature2: "Dukungan OEM/ODM",
    heroBanner1Feature3: "Layanan 6S · Eksklusif industri",
    heroBanner1Feature4: "Dukungan kustomisasi solusi",
  },
  ar: {
    heroBanner1Title: "مصنع معتمد من SGS",
    heroBanner1MetricPrefix: "الإنتاج السنوي",
    heroBanner1MetricSuffix: "وحدة",
    heroBanner1Feature1: "تصدير الآلات إلى 172 دولة",
    heroBanner1Feature2: "دعم OEM/ODM",
    heroBanner1Feature3: "خدمة 6S · حصرية في الصناعة",
    heroBanner1Feature4: "دعم تخصيص الحلول",
  },
  pl: {
    heroBanner1Title: "FABRYKA Z CERTYFIKATEM SGS",
    heroBanner1MetricPrefix: "ROCZNA PRODUKCJA",
    heroBanner1MetricSuffix: "SZT.",
    heroBanner1Feature1: "Eksport maszyn do 172 krajów",
    heroBanner1Feature2: "Wsparcie OEM/ODM",
    heroBanner1Feature3: "Usługa 6S · Unikalna w branży",
    heroBanner1Feature4: "Wsparcie rozwiązań na zamówienie",
  },
};
